function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.81 8a.55.55 0 01.55-.55h5.427l-1.53-1.589a.55.55 0 11.792-.763l2.427 2.52a.55.55 0 010 .763l-2.427 2.52a.55.55 0 11-.792-.763l1.53-1.588H4.36A.55.55 0 013.81 8zM8 13.9A5.9 5.9 0 108 2.1a5.9 5.9 0 100 11.8zM8 15A7 7 0 108 1a7 7 0 100 14z",
  fill: "currentcolor"
});

function SvgCircleArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiIgd2lkdGg9IjIxIiBoZWlnaHQ9IjIxIiBmaWxsPSJub25lIiB4bWxuczp2PSJodHRwczovL3ZlY3RhLmlvL25hbm8iPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTMuODEgOGEuNTUuNTUgMCAwIDEgLjU1LS41NWg1LjQyN2wtMS41My0xLjU4OWEuNTUuNTUgMCAxIDEgLjc5Mi0uNzYzbDIuNDI3IDIuNTJhLjU1LjU1IDAgMCAxIDAgLjc2M2wtMi40MjcgMi41MmEuNTUuNTUgMCAxIDEtLjc5Mi0uNzYzbDEuNTMtMS41ODhINC4zNkEuNTUuNTUgMCAwIDEgMy44MSA4ek04IDEzLjlBNS45IDUuOSAwIDEgMCA4IDIuMWE1LjkgNS45IDAgMSAwIDAgMTEuOHpNOCAxNUE3IDcgMCAxIDAgOCAxYTcgNyAwIDEgMCAwIDE0eiIgZmlsbD0iY3VycmVudGNvbG9yIi8+PC9zdmc+";
export { SvgCircleArrowRight as ReactComponent };